import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Yükleniyor…</div>;
  if (user) return <Navigate to={user.onboarded ? "/panel" : "/karsilama"} replace />;
  return children;
}
